<template>
    <div class="famous-pedia-life-story">
        <!-- 1. 名人简介 -->
        <div class="famous-pedia-cf-info">
            <div v-if="curPediaPipanInfo.base" class="famous-pedia-cfi-base">
                <!-- <p>名人简介：</p> -->
                <comment-content-read
                    v-bind:className="'famous-pedia-cfi-base-content'"
                    v-bind:textId="'base'"
                    v-bind:textValue="curPediaPipanInfo.base">
                </comment-content-read>
                <!-- <p v-html="UTILS.getBreakLineByText(curPediaPipanInfo.base)"></p> -->
            </div>
            <div class="famous-pedia-cfi-author-info">
                <div class="famous-pedia-cfi-author">创建者：{{curPediaBaziEditInfo.creatorName}}</div>
                <div class="famous-pedia-cfi-info">
                    <p><span class="famous-pedia-cfi-span-gray">浏览次数：</span>{{curPediaBaziEditInfo.pvTime}}次</p>
                    <p><span class="famous-pedia-cfi-span-gray">编辑次数：</span>{{curPediaBaziEditInfo.editTime}}次 <span class="famous-pedia-cfi-span-history" @click="clickEditHistory">编辑历史</span></p>
                    <p><span class="famous-pedia-cfi-span-gray">最近更新：</span>{{curPediaBaziEditInfo.editLastName}} ({{curPediaBaziEditInfo.editLastTime}})</p>
                </div>
            </div>
        </div>
        <!-- 2. 大运流年详细事迹 -->
        <div id="dayunliunian" class="famous-pedia-cf-content">
            <div class="famous-pc-title">
                <span class="famous-pcs-title">大运流年详细事迹</span>
                <!-- <span class="famous-pcs-edit-box">
                    <span class="famous-pcs-edit" @click="clickComment">评论</span>
                </span> -->
            </div>
            <div class="famous-pedia-create-dyln-list">
                <div class="famous-pedia-create-dyln-item-box" v-for="dayunData of curPediaDayunLiunianList" v-bind:key="dayunData.name" >
                    <div class="famous-pedia-create-dyln-item" v-if="dayunData && dayunData.edited" v-bind:id="dayunData.name">
                        <!-- 大运信息部分 -->
                        <div class="famous-pc-dyln-dayun-info">
                            <div class="famous-pc-dyln-title-box" @click.stop="clickTitle('dayun' + dayunData.year)">
                                <span class="famous-pc-dyln-title"><span class="famous-pc-dyln-title-title">{{dayunData.ganzhi}}{{dayunData.before ? '' : '大运'}}</span>{{dayunData.year}}-{{dayunData.year+dayunData.liunian.length-1}}</span>
                            </div>
                        </div>
                        <!-- 流年信息部分 -->
                        <div class="famous-pc-dyln-liunian-list">
                            <div v-for="liunianData of dayunData.liunian" v-bind:key="liunianData.year" class="famous-pc-dyln-liunian-item-box">
                                <div v-if="liunianData && liunianData.edited" v-bind:id="liunianData.name" class="famous-pc-dyln-liunian-item">
                                    <div class="famous-pc-dyln-ln-title">
                                        <span @click.stop="clickTitle('liunian' + liunianData.year)">
                                            <span class="famous-pc-dyln-ln-title-title">{{liunianData.year}}</span>{{liunianData.ganzhi}}流年
                                            <span class="famous-pc-dyln-ln-title-year">虚岁:{{liunianData.age}}</span>
                                        </span>
                                        <span class="famous-pc-dyln-icon" @click.stop="clickReply(dayunData, liunianData)">
                                            <span class="famous-pc-dyln-icon-num">{{commentTotalReplyData['big_' + dayunData.key + '_' + liunianData.key] ? commentTotalReplyData['big_' + dayunData.key + '_' + liunianData.key].length : ''}}</span>
                                            <i class="iconfont icon-comment-1"></i>
                                        </span>
                                    </div>
                                    <div v-if="liunianData.content" class="famous-pc-dyln-ln-paragraph">
                                        <p v-html="UTILS.getBreakLineByText(liunianData.content)"></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 最后一行 -->
            <div class="famous-pc-dyln-liunian-last-box"><div class="famous-pc-dyln-liunian-last"></div></div>
        </div>
    </div>
</template>
<script>
import { UTILS, UA } from '../../modules/utils'
import { DOM, FAMOUS_DOM } from '../../modules/dom';
import CommentContentRead from '../../layouts/comment/CommentContentRead.vue'
export default {
    name: 'FamousLifeStory',
    components: { CommentContentRead },
    computed: {
        curPediaPipanInfo() {
            return this.$store.state.famouspedia.curPediaPipanInfo;
        },
        curPediaBaziEditInfo() {
            return this.$store.state.famouspedia.curPediaBaziEditInfo
        },
        curPediaDayunLiunianList() {
            return this.$store.state.famouspedia.curPediaDayunLiunianList;
        },
        commentTotalReplyData() {
            return this.$store.state.famouspediacomment.commentTotalReplyData;
        }
    },
    data() {
        return {
            UTILS: UTILS,
        }
    },
    methods: {
        clickEditHistory() {
            this.$store.dispatch('famouspedia/getBaikeLog');
            var curPath = this.$router.history.current.path;
                curPath = curPath + '/edithistory';
            if(curPath.indexOf('embedded') != -1) {
                curPath = this.$router.history.current.fullPath;
                curPath = curPath.replace('famouspediaread', 'famouspediaread/edithistory')
            }
            this.$router.replace(curPath);
            DOM.hidePageByClassName('famous-pedia-create-form');
            DOM.hidePageByClassName('famous-comment-bottom-bar');
        },
        clickComment() {
            // 跳转到评论
            this.$store.state.famouspedia.curPediaContentTab = 2;
            var baikeId = this.$store.state.famouspedia.curPediaBaziId;
            this.$store.dispatch('famouspediacomment/initCommentList', baikeId);
        },
        clickTitle(itemId) {
            this.$bus.emit('triggerTitleLinkItem', itemId)
        },
        clickReply(dayunData, liunianData) {
            var me = this,
                curId = this.$store.state.famouspedia.curPediaBaziId,
                key = 'big_' + dayunData.key + '_' + liunianData.key,
                itemId = 'liunian' + liunianData.year;
            FAMOUS_DOM.bindFamousFormScrollEvent(false);
            this.$store.dispatch('famouspediacomment/setCommentFormData', {
                formData: {
                    bid: curId,
                    f_type: key,
                    parentsid: 0,
                    touid: 0
                },
                cb: function() {
                    setTimeout(() => {
                        if(!UA.isIphone()) {
                            FAMOUS_DOM.focusBottomBarTextArea();
                        }
                    }, 20);
                }
            })
            this.$store.dispatch('famouspediacomment/initCommentAllListData', {
                key: key,
                cb: function() {
                    setTimeout(() => {
                        FAMOUS_DOM.updateFamousFormStyle();
                        me.$bus.emit('focusFamousBottomBar');
                        window.scrollTo(0, 0); //这里要滚动到评论的顶部
                    }, 20);
                    setTimeout(() => {
                        me.$store.dispatch('minifatefortune/triggerFortuneItemFunction', itemId);
                    }, 100);
                }
            });
        }
    }
}
</script>